import { render, staticRenderFns } from "./batch-goods.vue?vue&type=template&id=72b69dee&"
import script from "./batch-goods.vue?vue&type=script&lang=js&"
export * from "./batch-goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports